import React from 'react';

const OrganismoCard = ({ organismo }) => {
  if (!organismo) {
    return null;
  }

  const getColorFromName = (nombre = '') => {
    let hash = 0;
    let hasNumbers = false;
    let numberSum = 0;
    
    for (let i = 0; i < nombre.length; i++) {
      const char = nombre[i];
      const code = nombre.charCodeAt(i);
      
      if (char >= '0' && char <= '9') {
        hasNumbers = true;
        const numValue = parseInt(char, 10);
        numberSum += numValue * 3;
        hash += numValue * 37;
      }
      
      hash = code + ((hash << 5) - hash);
    }
    
    if (hasNumbers) {
      hash += numberSum * 17;
    }
    
    const h = Math.abs(hash) % 360;
    const s = hasNumbers 
      ? 65 + (Math.abs(hash) % 20)
      : 60 + (Math.abs(hash) % 20);
    const l = hasNumbers
      ? 40 + (Math.abs(hash >> 2) % 20)
      : 45 + (Math.abs(hash) % 10);

    return `hsl(${h}, ${s}%, ${l}%)`;
  };

  const {
    nombre = 'Sin nombre',
    operaciones = 0,
    importe = 0,
    pvp = 0,
    porcentajeOperaciones = 0,
    porcentajeImporte = 0,
    porcentajePvp = 0,
    cantidad = 0,
    porcentajePVPTotal = 0
  } = organismo;

  const avatarColor = getColorFromName(nombre);

  const formatCurrency = (value) => {
    return Number(value).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const formatNumber = (value) => {
    return Number(value).toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  };

  const formatPercent = (value) => {
    const num = Number(value);
    const sign = num >= 0 ? '+' : '';
    return `${sign}${num.toFixed(1)}%`;
  };

  return (
    <div className="team-card">
      <div className="team-info">
        <div
          className="team-avatar"
          style={{ background: avatarColor }}
        >
          {nombre.charAt(0).toUpperCase()}
        </div>
        
        <div className="team-details">
          <h3>{nombre}</h3>
        </div>
      </div>

      {/* Grid responsive usando flex-wrap y flex-basis */}
      <div className="team-metrics" style={{ flexWrap: 'wrap' }}>
        <div className="team-metric" style={{ flex: '1 1 calc(50% - 8px)' }}>
          <span className="metric-label">Operaciones</span>
          <span className="metric-value">{formatNumber(operaciones)}</span>
          <span className={`metric-percent ${porcentajeOperaciones >= 0 ? 'positive' : 'negative'}`}>
            {formatPercent(porcentajeOperaciones)}
          </span>
        </div>
        
        <div className="team-metric" style={{ flex: '1 1 calc(50% - 8px)' }}>
          <span className="metric-label">Unidades</span>
          <span className="metric-value">{formatNumber(cantidad)}</span>
        </div>

        <div className="team-metric" style={{ flex: '1 1 calc(50% - 8px)' }}>
          <span className="metric-label">PVP</span>
          <span className="metric-value">{formatCurrency(pvp)} €</span>
          <span className={`metric-percent ${porcentajePvp >= 0 ? 'positive' : 'negative'}`}>
            {formatPercent(porcentajePvp)}
          </span>
        </div>

        <div className="team-metric" style={{ flex: '1 1 calc(50% - 8px)' }}>
          <span className="metric-label">Importe</span>
          <span className="metric-value">{formatCurrency(importe)} €</span>
          <span className={`metric-percent ${porcentajeImporte >= 0 ? 'positive' : 'negative'}`}>
            {formatPercent(porcentajeImporte)}
          </span>
        </div>
      </div>

      {/* Barra de progreso al final usando clases existentes */}
      <div className="worker-progress" style={{ 
        marginTop: '16px', 
        paddingTop: '16px', 
        borderTop: '1px solid rgba(255, 255, 255, 0.06)' 
      }}>
        <div className="progress-header">
          <span className="progress-label">% del Total PVP</span>
          <span className="progress-value" style={{ color: avatarColor }}>
            {Number(porcentajePVPTotal).toFixed(1)}%
          </span>
        </div>
        <div className="progress-bar-bg">
          <div 
            className="progress-bar-fill" 
            style={{ 
              width: `${Math.min(Math.max(porcentajePVPTotal, 0), 100)}%`,
              background: avatarColor
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OrganismoCard;